export default __webpack_public_path__ + "static/media/application.ddaeda20.svg";